import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@insolution/store-data-access';
import { IUserSettings } from '../interfaces/user-settings.interface';

@Injectable({ providedIn: 'root' })
export class UserSettingsService {
  private localStorageService = inject(LocalStorageService);

  public getSetting<K extends keyof IUserSettings>(key: K): IUserSettings[K] | null {
    const settings = this.localStorageService.getItemByUser('userSettings') as IUserSettings | null;
    const value = settings?.[key];
    return value === undefined ? null : value;
  }

  public setSetting<K extends keyof IUserSettings>(key: K, value: IUserSettings[K]): void {
    const settings = (this.localStorageService.getItemByUser('userSettings') as IUserSettings | null) ?? {};
    settings[key] = value;
    this.localStorageService.storeItemByUser('userSettings', settings as Record<string, unknown>);
  }

  public removeSetting<K extends keyof IUserSettings>(key: K): void {
    const settings = this.localStorageService.getItemByUser('userSettings') as IUserSettings | null;
    if (!settings || !(key in settings)) {
      return;
    }
    delete settings[key];
    this.localStorageService.storeItemByUser('userSettings', settings as Record<string, unknown>);
  }
}
